import { Component, OnInit } from "@angular/core";

import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { InsaCronService, TaskListService } from "../../../insa-services";
import { TaskModel } from "../../../insa-models";


@Component({
    selector: "insa-task-list",
    template: require("./insa-task-list.component.html")
    //styles: [require("./insa-job-form.component.css").toString()]
})
export class InsaTaskListComponent {
    public taskListName: string = "TaskList";

    
    


    /*userAcc: any[];
    priorities: any[];
    isTaskList: boolean = true;
    taskForm: boolean = false;
    taskData: TaskModel = new TaskModel();
    taskFinal: TaskModel = new TaskModel();
    editTaskModel: FormGroup;

    constructor(private _insaChronosService: InsaCronService, private _taskListService: TaskListService, private _fb: FormBuilder) { }

    // editTaskActivityForm = this._fb.group({
    //     ActivityID: new FormControl(null),
    //     AssignedUserID: new FormControl(null),
    //     SecAssignedUserID: new FormControl(null),
    //     isPrivate: new FormControl(false),
    //     TaskPriority: new FormControl(null),
    //     Text: new FormControl(""),
    //     DueDate: new FormControl(null),
    //     Notes: new FormControl(""),
    //     AwaitTaskCompletion: new FormControl(false)
    // });

    //editTaskActivityForm = this._fb.group({});

    addTask() {
        this.taskForm = true;
        //this.isTaskList = false;
        console.log("blabla")
        //this.selectedItem = new ChronosActivityResultActions();

        this.editTaskModel = new FormGroup({
            //TaskID: new FormControl(null),
            AssignedUserID: new FormControl(null),
            SecAssignedUserID: new FormControl(null),
            isPrivate: new FormControl(false),
            TaskPriority: new FormControl(null),
            Text: new FormControl(""),
            DueDate: new FormControl(null),
            Notes: new FormControl(""),
            //AwaitTaskCompletion: new FormControl(false)
        });
    }

    hideModal() {
        this.taskForm = false;
        //this.isTaskList = true;
    }

    saveAndClose(editedTask: any) {

        console.log(editedTask);

        this._insaChronosService.addTask(editedTask).subscribe();
        
        this.taskForm = false;
    }

    ngOnInit(){
        this._insaChronosService.getPriorities().subscribe(p => this.priorities = p );
        this._insaChronosService.getUserAcc().subscribe(u => this.userAcc = u);
    }*/


}


// WEBPACK FOOTER //
// ./app/insa-components/insa-cron/insa-task-list/insa-task-list.component.ts